(function ($) {
    var componentMap = {
        initMap: function () {
            if (!$('#map, #gmap, .map, .gmap').length) {
                return;
            }
            var mapContainerElementSelector = '#map';

            if ($('#gmap').length) {
                mapContainerElementSelector = '#gmap';
            }
            if ($('.map').length) {
                mapContainerElementSelector = '.map';
            }
            if ($('.gmap').length) {
                mapContainerElementSelector = '.gmap';
            }

            var gmapMarkersClusteringActivation = parseInt($('#gmap-markers-clustering').text());
            var positions = [];
            var markers   = [];
            var markersClusters = [];
            var cpteur    = 0;
            var bounds    = new google.maps.LatLngBounds();
            var zoomVal   = 0;
            var lats      = 0;
            var lngs      = 0;
            var zones     = [];

            $('#gmapData span[data-role="gmap-location-item"]').each(function () {
                cpteur++;
                positions[$(this).attr('data-id')] =
                    new google.maps.LatLng($(this).attr('data-latitude'), $(this).attr('data-longitude'))
                ;
                bounds.extend(positions[$(this).attr('data-id')]);
            });

            for (const [index, ] of positions.entries()) {
                if (positions.hasOwnProperty(index)) {
                    lats += positions[index].lat();
                    lngs += positions[index].lng();
                }
            }

            var centerLat = lats / cpteur;
            var centerLng = lngs / cpteur;

            if (cpteur === 1) {
                zoomVal = parseInt($('#gmapData span[data-role="gmap-location-item"]').attr('data-zoom'));
            } else {
                zoomVal = 6;
            }
            var googleMapsLatLng = new google.maps.LatLng(centerLat, centerLng);

            var mapOptions = {
                zoom: zoomVal,
                center: googleMapsLatLng
            };
            if ($(window).width() < 501) {
                mapOptions = {
                    zoom: zoomVal,
                    center: googleMapsLatLng,
                    streetViewControl: false,
                    fullscreenControl: false,
                    mapTypeControl: false
                };
            }
            var mapElement = $(mapContainerElementSelector)[0]; // We will be binded to the DOM Element
            var map = new google.maps.Map(mapElement, mapOptions);
            var infowindow = new google.maps.InfoWindow({minWidth: 700, maxWidth: 900});

            if (cpteur > 1) {
                map.fitBounds(bounds);
            }

            for (const [key,] of positions.entries()) {
                if (positions.hasOwnProperty(key)) {
                    var contentString = '';
                    var agenceRoot = $('#gmapData span[data-role="gmap-location-item"][data-id="' + key + '"]');

                    contentString = $('.agencies-list ul li[data-id="' + key + '"]').html();
                    infowindow.setOptions({
                        content: contentString
                    });

                    var nomAgence = agenceRoot.attr('data-villeweb');

                    var marker = new google.maps.Marker({
                        position: positions[key],
                        title: nomAgence,
                        map: map,
                        animation: google.maps.Animation.DROP,
                        icon: "/images/v3/specifique_client/" + $('#client-reference').text() + "/icons/map-icon.png",
                        content: contentString
                    });
                    if (gmapMarkersClusteringActivation === 1) {
                        if (markersClusters[agenceRoot.attr('data-id-zone')] === undefined) {
                            markersClusters[agenceRoot.attr('data-id-zone')] = [];
                        }
                        markersClusters[agenceRoot.attr('data-id-zone')][key] = marker;
                        zones.push(agenceRoot.attr('data-id-zone'));
                    } else {
                        markers[key] = marker;
                        marker.setMap(map);
                    }
                    if (
                        (
                            $('#agency-geolocation-infos-display').length &&
                            parseInt($('#agency-geolocation-infos-display').attr('data-value')) === 1
                        ) ||
                        !$('#agency-geolocation-infos-display').length
                    ) {
                        google.maps.event.addListener(marker, 'click', function (event) {
                            infowindow.setContent(this.content);
                            infowindow.open(this.map, this);
                        });
                        $('.address[data-id="' + key + '"]').click(function () {
                            google.maps.event.trigger(markers[$(this).attr('data-id')], 'click');
                        });
                    }
                }
            }
            var mcOptions = {
                styles:[{
                    url: "/images/v3/specifique_client/" + $('body').attr('data-reference-client') + "/icons/m1.png",
                    width: 53,
                    height:53,
                    fontFamily:$('#gmap-cluster-text-font').attr('data-font'),
                    textSize:12,
                    textColor: $('#gmap-cluster-text-color').attr('data-color'),
                }],
            }
            if (gmapMarkersClusteringActivation === 1) {
                positions.push(new MarkerClusterer(map, markersClusters[zones[0]], mcOptions));
            }

            google.maps.event.addListener(map, "idle", function () {
                if (cpteur > 1 && parseInt($('#initial-fitbounds-done').text()) === 0) {
                    map.fitBounds(bounds);
                    $('#initial-fitbounds-done').text(1);
                }
            });
        }
    }
    $.fn.initGoogleMap = function () {
        componentMap.initMap();
    }
})(jQuery);
